import { SET_DEEPDRIVE_TAB, SET_VIEW_POWER_BI } from "../../Actions/Types";
import { SET_VIEW_POWER_BI_ALERTS } from "../../Actions/Types";
import { SET_VIEW_POWER_BI_DATA } from "../../Actions/Types";

const initialState = {
  viewPowerBi: false,
  viewPowerBiAlerts: false,
  viewPowerBiData:[],
  deepDriveTab:""
};

const viewPowerBiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VIEW_POWER_BI:
      return {
        ...state,
        viewPowerBi: action.payload,
      };
      case SET_VIEW_POWER_BI_ALERTS:
        return {
          ...state,
          viewPowerBiAlerts: action.payload,
        };
        case SET_VIEW_POWER_BI_DATA: 
        return {
          ...state,
          viewPowerBiData: action.payload,
        };
        case SET_DEEPDRIVE_TAB: 
        return {
          ...state,
          deepDriveTab: action.payload,
        };
    default:
      return state;
  }
};

export default viewPowerBiReducer;
